import { accountDetails } from "@di";
import DpBillsRepository from "@adapters/repositories/Reports/DpBills";
export default (http) => {
    return {
        dpBillReport: new DpBillsRepository(http, accountDetails),
    };
};
